import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Link from '@mui/material/Link';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useTheme } from '@mui/material';
import img from "../assets/OIG42.jpg";
import { useTranslation } from 'react-i18next';
export interface SideLogginLayoutProps {
    children?: any
}

export const SideLogginLayout = (props : SideLogginLayoutProps) => {
    const theme = useTheme();
    const [t] = useTranslation("common");
    return <>
        <ThemeProvider theme={theme}>
            <Grid container component="main" sx={{ height: '100vh' }}>
                <CssBaseline />
                <Grid
                    item
                    xs={false}
                    sm={4}
                    md={7}
                    sx={{
                      
                        backgroundColor: (t) =>
                            (theme as any).background.primarycontrast,
                    }}
                >
                  
                    <div style={{textAlign:"center",position:"relative",top:"20%"}}>
                        <Typography variant='h1'>{t("login.welcometext1")}</Typography>
                        <img style={{width:"25%"}} src={img}></img>
                        <Typography variant='h2'>{t("login.welcometext2")}</Typography>
                    </div>
                   
                    </Grid>
               
                <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
                    <Box
                        sx={{
                            my: 8,
                            mx: 4,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <>{props.children}</>
                        {/* <Typography variant="body2" color="text.secondary" align="center" {...props}>
                            {'Copyright © '}
                            <Link color="inherit" href="https://globis-consulting.be/">
                                Globis
                            </Link>{' '}
                            {new Date().getFullYear()}
                            {'.'}
                        </Typography> */}
                    </Box>
                </Grid>
            </Grid>
        </ThemeProvider>
    
    </>
}